import { State } from '../../../main/reducers/rootReducer';
import { createSelector } from 'reselect';

export const getI18nState = (state: State) => state.i18n;

export const getLocale = createSelector(getI18nState, s => s.locale);
export const getLocales = createSelector(getI18nState, s => s.locales);
